import PropTypes from 'prop-types';
import React from 'react';

import ExperienceButtons from '@glass/shared/components/Section/ExperienceSection/ExperienceButtons';
import Section from '@glass/shared/components/Section/Section';

const ExperienceSection = React.forwardRef(
  (
    {
      title,
      subtitle,
      options,
      isAlternatingColor,
      onButtonClick,
      disableCta,
      isNoXPadding,
      overflow,
      outerSpacing,
      spacing,
      type,
      persistQueryParams,
      shallow,
      ctaQueryParams,
      ctaText,
      titleComponent,
      titleVariant,
    },
    ref,
  ) => {
    return (
      <Section
        ref={ref}
        ctaQueryParams={ctaQueryParams}
        ctaText={ctaText}
        disableCta={disableCta}
        isAlternatingColor={isAlternatingColor}
        isNoXPadding={isNoXPadding}
        outerSpacing={outerSpacing}
        overflow={overflow}
        spacing={spacing}
        subtitle={subtitle}
        title={title}
        titleComponent={titleComponent}
        titleVariant={titleVariant}
        type={type}
      >
        <ExperienceButtons
          options={options}
          persistQueryParams={persistQueryParams}
          shallow={shallow}
          onClick={onButtonClick}
        />
      </Section>
    );
  },
);

ExperienceSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  ctaQueryParams: PropTypes.object,
  ctaText: PropTypes.string,
  disableCta: PropTypes.bool,
  isAlternatingColor: PropTypes.bool,
  isNoXPadding: PropTypes.bool,
  onButtonClick: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      params: PropTypes.object,
      text: PropTypes.string.isRequired,
    }),
  ),
  outerSpacing: PropTypes.number,
  overflow: PropTypes.string,
  persistQueryParams: PropTypes.bool,
  shallow: PropTypes.bool,
  spacing: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  titleComponent: PropTypes.string,
  titleVariant: PropTypes.string,
  type: PropTypes.string,
};

export default React.memo(ExperienceSection);
